import { createForm } from '../../../factories'

export default createForm(['email'])



// WEBPACK FOOTER //
// ./src/store/modules/register/forms/forgotPassword.js